<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :label="$t('SeaExport.batchImportCharge')" name="batchImportCharge" :lazy="true">
              <batch-import-charge ref="batchImportCharge" :lob="lob" />
            </el-tab-pane>
            <el-tab-pane :label="$t('SeaExport.historyLogQuery')" name="importRecordSearch" :lazy="true">
              <import-record-search ref="importRecordSearch" :lob="lob" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import batchImportCharge from '@/components/Cargo/Job/importCharge/batchImportCharge'
import importRecordSearch from '@/components/Cargo/Job/importCharge/importRecordSearch'

export default {
  name: 'ImportChargeTab',
  components: { batchImportCharge, importRecordSearch },
  props: {
    lob: { type: String, required: true } // 业务类型
  },
  data() {
    return {
      activeTabName: 'batchImportCharge'
    }
  },
  created() {
    this.handleClick()
  },
  methods: {
    // tab 页签点击事件
    handleClick() {
      this.$nextTick(() => {
        this.$refs[this.activeTabName].onShow()
      })
    }
  }
}
</script>

<style scoped>

</style>
